import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import type { RootState } from "redux/store";

const SLICE = "recentSearch";

// Keys mirror the GlobalSearch category names returned by categoryData()
export interface RecentSearchState {
  [category: string]: any[];
}

// One isolated bucket of recent searches per hltId
export interface RecentSearchByUser {
  [hltId: string]: RecentSearchState;
}

const defaultRecentSearch: RecentSearchState = {
  Member: [],
  Property: [],
  "Library Plan": [],
  "Template Plan": [],
  "Property Plan": []
};

const initialState: { recentSearch: RecentSearchByUser } = {
  recentSearch: {}
};

export const RecentSearchSlice = createSlice({
  name: SLICE,
  initialState,
  reducers: {
    // seeds the hltId bucket and backfills categories absent from previously persisted state
    setRecentSearch: (state, action: PayloadAction<{ hltId: string; recentSearch: RecentSearchState }>) => {
      const { hltId, recentSearch } = action.payload;
      state.recentSearch[hltId] = { ...defaultRecentSearch, ...state.recentSearch[hltId], ...recentSearch };
    }
  }
});

export const selectRecentSearch = (hltId: string) => (state: RootState) =>
  state.recentSearchDetails.recentSearch[hltId] ?? defaultRecentSearch;

// mirrors getUserHltId(), but as a selector so consumers re-render when the acting user changes
export const selectUserHltId = (state: RootState) => {
  const { isImpersonated, userDetails } = state.app.impersonationDetails;
  return (isImpersonated ? userDetails?.hltId : localStorage.getItem("hltId")) ?? "";
};

export const { setRecentSearch } = RecentSearchSlice.actions;

export default RecentSearchSlice.reducer;
